<script setup lang="ts">
import PrintTemplatesTable from '../../components/TemplatesComponents/PrintTemplatesTable.vue'
</script>

<template>
    <PrintTemplatesTable />
</template>
